import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'findByKey',
  standalone: true,
})
export class FindByKeyPipe<T> implements PipeTransform {
  transform(value: T[], key: keyof T, search: T[keyof T] | T[keyof T][]): T | undefined {
    if (!Array.isArray(value) || !value.length || !key || search == null) return undefined;

    // Normalize search term(s) into an array
    const searchArray = Array.isArray(search) ? search : [search];

    return value.find(item =>
      searchArray.some(term => this.compareValues(item[key], term))
    );
  }

  private compareValues(a: any, b: any): boolean {
    if (typeof a === 'string' && typeof b === 'string') {
      return a.toLowerCase() === b.toLowerCase();
    }
    return a === b;
  }
}
